<script lang="ts">
    import s from './button.module.css';

    import cn from 'classnames';
    import { SvgIcon, IconName } from '@uikit/svg-icon';
    import { type Props, TagName } from './types';

    export let text: Props['text'] = '';
    export let custom: Props['custom'] = false;
    export let disabled: Props['disabled'] = false;
    export let dropdown: Props['dropdown'] = false;
    export let rounded: Props['rounded'] = false;
    export let fullWidth: Props['fullWidth'] = false;
    export let type: Props['type'] = undefined;
    export let element: Props['element'] = undefined;
    export let href: Props['href'] = undefined;
    export let target: Props['target'] = undefined;
    export let color: Props['color'] = undefined;
    export let size: Props['size'] = undefined;
    export let icon: Props['icon'] = undefined;
    export let iconRight: Props['iconRight'] = undefined;
    export let tagName: Props['tagName'] = href ? TagName.a : TagName.button;
    export let classes: Props['classes'] = '';
    export let attrs: Props['attrs'] = {};
    export let iconRotationAngle: Props['iconRotationAngle'] = undefined;
    export let iconRightRotationAngle: Props['iconRightRotationAngle'] = undefined;
    export let iconProps: Props['iconProps'] = {};
    export let iconRightProps: Props['iconRightProps'] = {};
    export let hasPadding: Props['hasPadding'] = true;

    const rootClass = custom ? '' : s.root;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    $: hasText = Boolean($$slots.default || text);

    $: rootClasses = cn(
        rootClass,
        size && s[`size-${size}`],
        color && s[`color-${color}`],
        { [s.disabled]: disabled },
        { [s.rounded]: rounded },
        { [s.hasLeftIcon]: icon },
        { [s.hasRightIcon]: iconRight },
        { [s.noText]: !hasText },
        { [s.dropdown]: dropdown },
        { [s.fullWidth]: fullWidth },
        { [s.noPadding]: !hasPadding },
        classes,
    );
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element
    this={tagName}
    bind:this={element}
    class={rootClasses}
    {href}
    {target}
    {disabled}
    {type}
    {...attrs}
    on:click
>
    {#if icon}
        <SvgIcon
            {...iconProps}
            classes={cn(s.icon, iconProps?.classes)}
            {icon}
            rotationAngle={iconRotationAngle}
            svgClasses={iconProps?.svgClasses}
        />
    {/if}

    {#if text}
        {text}
    {:else}
        <slot />
    {/if}

    {#if iconRight}
        <SvgIcon
            {...iconRightProps}
            classes={cn(s.iconRight, iconRightProps?.classes)}
            icon={iconRight}
            rotationAngle={iconRightRotationAngle}
            svgClasses={iconRightProps?.svgClasses}
        />
    {/if}

    {#if dropdown}
        <SvgIcon classes={s.dropdownIcon} icon={IconName.DropDownIcon} />
    {/if}
</svelte:element>
